export default __webpack_public_path__ + "static/media/rare-confetti.f5106e35.webm";